<template>
  <div class="image">
    <!-- <img src="../assets/images/item.png" style="width:100%;height:100%;object-fit:cover;"> -->
    <span class="title2">
      备件价格查询
    </span>
  </div>

  <div style="display:flex; justify-content:center">
    <div style="width:1200px">
      <div style="margin-top:50px; text-align:left">
        <span class="title" style="">请选择手机型号：</span><br /><br /><br />
        <img src="../assets/images/type.png" style="height:100%; " /><br /><br /><br />
        <div class="container">
          <div>
            <input type="text" placeholder="请输入机型" @click="show = true" v-model="selectphone" />
            <!-- <i class="el-icon-search" style="font-size:24px; position:absolute; left:00px; margin-right:20px;margin-top:9px"></i> -->
          </div>

          <div style="margin-top:20px; margin-left:0vw; font-size:18px; z-index:-1; overflow:auto" class="content"
            v-show="show">
            <div v-for="phone in phoneList" :key="phone" class="phone" style="margin-top:20px">
              <span style="font-size:24px; cursor:pointer" @click="
                () => {
                  if (phone.show == false) {
                    phone.show = true;
                  } else {
                    phone.show = false;
                  }
                }
              ">{{ phone.name }}</span>
              <div v-for="color in phone.value" :key="color" class="color" style="margin-left:20px; margin-top:20px"
                v-show="phone.show">
                <span v-if="color.indexOf('NZONE S7 Pro+') != -1" @click="
  show = false;
selectphone = color;
show2 = true;
show3 = false;
show1 = false;
show4 = false;
show5 = false;
show6 = false
                ">{{ color }}</span>
                <span v-else-if="color.indexOf('NZONE S7 Pro') != -1" @click="
  show = false;
selectphone = color;
show1 = true;
show3 = false;
show2 = false;
show4 = false;
show5 = false;
show6 = false
                ">{{ color }}</span>

                <span v-else-if="color.indexOf('NZONE S7 （SP100）6+128G公开版') != -1" @click="
  show = false;
selectphone = color;
show1 = false;
show3 = true;
show2 = false;
show4 = false;
show5 = false;
show6 = false
                ">{{ color }}</span>

                <span v-else-if="color.indexOf('NZONE S7 （SP100）8+128G公开版') != -1" @click="
  show = false;
selectphone = color;
show1 = false;
show3 = false;
show2 = false;
show4 = true;
show5 = false;
show6 = false
                ">{{ color }}</span>

                <span v-else-if="color.indexOf('NZONE 50 Pro（SP210）8+128G全网通') != -1" @click="
  show = false;
selectphone = color;
show1 = false;
show3 = false;
show2 = false;
show4 = false;
show5 = true;
show6 = false
                ">{{ color }}</span>
                <span v-else-if="color.indexOf('NZONE 50 Pro（SP210）8+256G全网通') != -1" @click="
  show = false;
selectphone = color;
show1 = false;
show3 = false;
show2 = false;
show4 = false;
show5 = false;
show6 = true
                ">{{ color }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="text-align:left; margin-left:5vw; margin-top:3vw">
        <!-- <span class="title2" style="margin-left:0; flex-shrink:0">{{selectphone}}</span> -->
      </div>

      <div class="show" v-show="show1">
        <div>
          <el-table :data="tabledata" style="max-width:1250px;"
            cell-style="color':'black;text-align:center;font-size:16px"
            header-cell-style="color:black;text-align:center;background-color:#E0E0E0; font-size:20px"
            row-style="height:30px" border="“true”">
            <el-table-column label="序号" type="index" width="400">
            </el-table-column>
            <el-table-column prop="name" label="项目" width="400">
              <template v-slot="scope">
                <div v-if="scope.row.name !== '电池'">{{ scope.row.name }}</div>
                <div v-else>
                  <span>{{ scope.row.name }}</span>
                  <span style="color: red"> (一口价换电池活动)</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="price" label="价格" width="400">
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div class="show" v-show="show2">
        <div>
          <el-table :data="tabledata1" style="max-width:1250px;"
            cell-style="color':'black;text-align:center;font-size:16px"
            header-cell-style="color:black;text-align:center;background-color:#E0E0E0; font-size:20px"
            row-style="height:30px" border="“true”">
            <el-table-column label="序号" type="index" width="400">
            </el-table-column>
            <el-table-column prop="name" label="项目" width="400">
              <template v-slot="scope">
                <div v-if="scope.row.name !== '电池'">{{ scope.row.name }}</div>
                <div v-else>
                  <span>{{ scope.row.name }}</span>
                  <span style="color: red"> (一口价换电池活动)</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="price" label="价格" width="400">
              <template v-slot="scope">
                <div v-if="(scope.row.price === 770)"> <span style="text-decoration: line-through;">770</span> 593</div>
                <div v-else>
                  <span>{{ scope.row.price }}</span>

                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div class="show" v-show="show3">
        <div>
          <el-table :data="tabledata2" style="max-width:1250px;"
            cell-style="color':'black;text-align:center;font-size:16px"
            header-cell-style="color:black;text-align:center;background-color:#E0E0E0; font-size:20px"
            row-style="height:30px" border="“true”">
            <el-table-column label="序号" type="index" width="400">
            </el-table-column>
            <el-table-column prop="name" label="项目" width="400">
              <template v-slot="scope">
                <div v-if="scope.row.name !== '电池'">{{ scope.row.name }}</div>
                <div v-else>
                  <span>{{ scope.row.name }}</span>
                  <span style="color: red"> (一口价换电池活动)</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="price" label="价格" width="400">
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div class="show" v-show="show4">
        <div>
          <el-table :data="tabledata3" style="max-width:1250px;"
            cell-style="color':'black;text-align:center;font-size:16px"
            header-cell-style="color:black;text-align:center;background-color:#E0E0E0; font-size:20px"
            row-style="height:30px" border="“true”">
            <el-table-column label="序号" type="index" width="400">
            </el-table-column>
            <el-table-column prop="name" label="项目" width="400">
              <template v-slot="scope">
                <div v-if="scope.row.name !== '电池'">{{ scope.row.name }}</div>
                <div v-else>
                  <span>{{ scope.row.name }}</span>
                  <span style="color: red"> (一口价换电池活动)</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="price" label="价格" width="400">
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div class="show" v-show="show5">
        <div>
          <el-table :data="tabledata4" style="max-width:1250px;"
            cell-style="color':'black;text-align:center;font-size:16px"
            header-cell-style="color:black;text-align:center;background-color:#E0E0E0; font-size:20px"
            row-style="height:30px" border="“true”">
            <el-table-column label="序号" type="index" width="400">
            </el-table-column>
            <el-table-column prop="name" label="项目" width="400">
              <template v-slot="scope">
                <div v-if="scope.row.name !== '电池'">{{ scope.row.name }}</div>
                <div v-else>
                  <span>{{ scope.row.name }}</span>
                  <span style="color: red"> (一口价换电池活动)</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="price" label="价格" width="400">
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div class="show" v-show="show6">
        <div>
          <el-table :data="tabledata5" style="max-width:1250px;"
            cell-style="color':'black;text-align:center;font-size:16px"
            header-cell-style="color:black;text-align:center;background-color:#E0E0E0; font-size:20px"
            row-style="height:30px" border="“true”">
            <el-table-column label="序号" type="index" width="400">
            </el-table-column>
            <el-table-column prop="name" label="项目" width="400">
              <template v-slot="scope">
                <div v-if="scope.row.name !== '电池'">{{ scope.row.name }}</div>
                <div v-else>
                  <span>{{ scope.row.name }}</span>
                  <span style="color: red"> (一口价换电池活动)</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="price" label="价格" width="400">
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div style="text-align:left; margin-top:100px; flex-shrink:0;margin-bottom:100px">
        <div style="text-align:center">
          <span class="title1" style="flex-shrink:0">备件价格收费说明</span><br /><br /><br />
        </div>
        <div style="text-align:left">
          <span class="content" style="flex-shrink:0">【温馨提示】</span><br /><br />
          <span class="content" style="flex-shrink:0">以上价格为维修建议价格，包含人工费，最终以NZONE授权客户服务中心检测、报价为准。</span>
        </div>

        <div style="text-align:center; margin-top:100px; margin-bottom:50px">
          <span class="title1" style="flex-shrink:0">保外收费说明</span>
        </div>

        <div style="text-align:left">
          <span class="content" style="flex-shrink:0">【温馨提示】</span><br /><br />
          <p class="content" style="flex-shrink:0">
            以下价格为维修建议价格，包含人工费，最终以NZONE授权客户服务中心检测、报价为准。无法查询的维修价格，请咨询NZONE授权客户服务中心。
          </p>
          <span class="content" style="flex-shrink:0">非保维修收费=维修备件物料费用+人工费，其中人工费参考价格如下：</span>
        </div>

        <div style="max-width:1300px; overflow:hidden; margin-top:50px" v-show="!show4 && !show5 && !show6">
          <el-table :data="repairList" cell-style="color':'black;text-align:center;font-size:16px"
            header-cell-style="color:black;text-align:center;background-color:#E0E0E0; font-size:20px"
            row-style="height:30px" border="“true”">
            <el-table-column prop="level" label="维修级别" width="300">
            </el-table-column>
            <el-table-column prop="content" label="服务内容" width="300">
            </el-table-column>
            <el-table-column prop="item" label="维修项目" width="450">
            </el-table-column>
            <el-table-column prop="price" label="人工费" width="150">
            </el-table-column>
          </el-table>
        </div>
        <div style="max-width:1300px; overflow:hidden; margin-top:50px" v-show="show4 || show5 || show6">
          <el-table :data="repairList1" cell-style="color':'black;text-align:center;font-size:16px"
            header-cell-style="color:black;text-align:center;background-color:#E0E0E0; font-size:20px"
            row-style="height:30px" border="“true”">
            <el-table-column prop="level" label="维修级别" width="300">
            </el-table-column>
            <el-table-column prop="content" label="服务内容" width="300">
            </el-table-column>
            <el-table-column prop="item" label="维修项目" width="450">
            </el-table-column>
            <el-table-column prop="price" label="人工费" width="150">
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>

  <!-- <el-divider></el-divider> -->
</template>

<script lang="ts">
import { defineComponent, onBeforeMount, ref } from "vue";
import * as api from "../api/apt";

interface phoneListProp {
  key: string;
  name: string;
  show: boolean;
  value: Array<string>;
}

interface tabledataProp {
  name: string;
  price: number;
}

interface repairdataProp {
  level: string;
  content: string;
  item: string;
  price: string;
}

export default defineComponent({
  data() {
    return {
      productId: "1",
      image: {
        height: "643px",
        position: "relative",
        backgroundImage:
          "linear-gradient(rgba(0, 0, 0, 0.5),rgba(0, 0, 0, 0.5)),url(" +
          require("../assets/images/item.png") +
          ")",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPositionY: "30%"
      }
    };
  },

  setup() {
    let tabledata = ref<tabledataProp[] | null>(null);
    let tabledata1 = ref<tabledataProp[] | null>(null);
    let tabledata2 = ref<tabledataProp[] | null>(null);
    let tabledata3 = ref<tabledataProp[] | null>(null);
    let tabledata4 = ref<tabledataProp[] | null>(null);
    let tabledata5 = ref<tabledataProp[] | null>(null)
    let phoneList = ref<phoneListProp[] | null>(null);
    let repairList = ref<repairdataProp[] | null>(null);
    let repairList1 = ref<repairdataProp[] | null>(null);
    let show = ref(false);
    let show1 = ref(false);
    let show2 = ref(false);
    let show3 = ref(false);
    let show4 = ref(false);
    let show5 = ref(false);
    let show6 = ref(false)
    let selectphone = ref("");
    // let getPresetPrice = (pid) => {
    //     api.getReplacementPrice(pid).then((res) => {

    //         let prices = res.data.result.results

    //         tabledata.value = prices

    //     })
    // }
    tabledata.value = [
      {
        name: "主板",
        price: 1232
      },
      {
        name: "前壳组件",
        price: 151
        // price: 629
      },
      {
        name: "后壳组件",
        price: 100
        // price: 189
      },
      {
        name: "主后摄像头64M",
        price: 335
      },
      {
        name: "后摄像头8M",
        price: 123
      },
      {
        name: "后摄像头2M",
        price: 99
      },
      {
        name: "前摄像头16M",
        price: 189
      },
      {
        name: "电池",
        price: 129
      }, {
        name: '外屏维修',
        price: 219
      }
    ];

    tabledata1.value = [
      {
        name: "主板",
        price: 1625
      },
      {
        name: "前壳组件",
        price: 195
        // price: 770  //593
      },
      {
        name: "后壳组件",
        price: 100
        // price: 209
      },
      {
        name: "主后摄像头64M",
        price: 345
      },
      {
        name: "后摄像头8M",
        price: 123
      },
      {
        name: "后摄像头2M",
        price: 101
      },
      {
        name: "前摄像头16M",
        price: 138
      },
      {
        name: "电池",
        price: 129
      },
      {
        name: '外屏维修',
        price: 269
      }
    ];

    tabledata2.value = [
      {
        name: "主板",
        price: 1246
      },
      {
        name: "屏幕组件",
        price: 449
      },
      {
        name: "电池",
        price: 129
      },
      {
        name: "前置摄像头组件",
        price: 120
      },
      {
        name: "后置摄像头组件",
        price: 146
      },
      {
        name: "后壳",
        price: 109
      },
      {
        name: '外屏维修',
        price: 219
      }
    ];

    tabledata3.value = [
      {
        name: "主板",
        price: 1260
      },
      {
        name: "屏幕组件",
        price: 449
      },
      {
        name: "电池",
        price: 181
      },
      {
        name: "前置摄像头组件",
        price: 120
      },
      {
        name: "后置摄像头组件",
        price: 146
      },
      {
        name: "后壳",
        price: 109
      },
      {
        name: '外屏维修',
        price: 219
      }

    ]

    tabledata4.value = [
      {
        name: "主板",
        price: 1249
      },
      {
        name: "前壳组件",
        price: 629
      },
      {
        name: '后壳组件',
        price: 206
      },
      {
        name: '主后摄像头50M',
        price: 239
      },
      {
        name: '后摄像头2M（景深）',
        price: 108
      },
      {
        name: '后摄像头2M（微距）',
        price: 98
      },
      {
        name: '前摄像头16M',
        price: 144
      },
      {
        name: "电池",
        price: 198
      },
    ]

    tabledata5.value = [
      {
        name: "主板",
        price: 1439
      },
      {
        name: "前壳组件",
        price: 629
      },
      {
        name: '后壳组件',
        price: 206
      },
      {
        name: '主后摄像头64M',
        price: 239
      },
      {
        name: '后摄像头8M',
        price: 108
      },
      {
        name: '后摄像头2M',
        price: 98
      },
      {
        name: '前摄像头16M',
        price: 144
      },
      {
        name: "电池",
        price: 198
      },
    ]

    phoneList.value = [
      {
        key: "3",
        show: false,
        name: "NZONE S7 Pro+ 5G （SP300）8+128G全网通",
        value: [
          "NZONE S7 Pro+ 5G （SP300）8+128G全网通 优雅黑",
          "NZONE S7 Pro+ 5G （SP300）8+128G全网通 月光银",
          "NZONE S7 Pro+ 5G （SP300）8+128G全网通 星空蓝"
        ]
      },

      {
        key: "4",
        show: false,
        name: "NZONE S7 Pro+ 5G （SP300）8+128G移动权益版",
        value: [
          "NZONE S7 Pro+ 5G （SP300）8+128G移动权益版 优雅黑",
          "NZONE S7 Pro+ 5G （SP300）8+128G移动权益版 月光银",
          "NZONE S7 Pro+ 5G （SP300）8+128G移动权益版 星空蓝"
        ]
      },
      {
        key: "1",
        show: false,
        name: "NZONE S7 Pro 5G （SP200）8+128G公开版",
        value: [
          "NZONE S7 Pro 5G （SP200）8+128G公开版 优雅黑",
          "NZONE S7 Pro 5G （SP200）8+128G公开版 金色阳光",
          "NZONE S7 Pro 5G （SP200）8+128G公开版 烟雨青蓝"
        ]
      },

      {
        key: "2",
        show: false,
        name: "NZONE S7 Pro 5G （SP200）8+128G权益版",
        value: [
          "NZONE S7 Pro 5G （SP200）8+128G权益版 优雅黑",
          "NZONE S7 Pro 5G （SP200）8+128G权益版 金色阳光",
          "NZONE S7 Pro 5G （SP200）8+128G权益版 烟雨青蓝"
        ]
      },

      {
        key: "5",
        show: false,
        name: "NZONE S7 （SP100）6+128G公开版",
        value: [
          "NZONE S7 （SP100）6+128G公开版 青山翠",
          "NZONE S7 （SP100）6+128G公开版 月光银",
          "NZONE S7 （SP100）6+128G公开版 优雅黑"
        ]
      },
      {
        key: '6',
        show: false,
        name: 'NZONE S7 （SP100）8+128G公开版',
        value: [
          "NZONE S7 （SP100）8+128G公开版 青山翠",
          "NZONE S7 （SP100）8+128G公开版 月光银",
          "NZONE S7 （SP100）8+128G公开版 优雅黑"
        ]
      },
      {
        key: '7',
        show: false,
        name: 'NZONE 50 Pro（SP210）8+128G全网通',
        value: [
          "NZONE 50 Pro（SP210）8+128G全网通 星海蓝",
          "NZONE 50 Pro（SP210）8+128G全网通 幻夜黑",
          "NZONE 50 Pro（SP210）8+128G全网通 翡冷翠",
          "NZONE 50 Pro（SP210）8+128G全网通 雪域白"
        ]
      },
      {
        key: '8',
        show: false,
        name: 'NZONE 50 Pro（SP210）8+256G全网通',
        value: [
          "NZONE 50 Pro（SP210）8+256G全网通 星海蓝",
          "NZONE 50 Pro（SP210）8+256G全网通 幻夜黑",
          "NZONE 50 Pro（SP210）8+256G全网通 翡冷翠",
          "NZONE 50 Pro（SP210）8+256G全网通 雪域白"
        ]
      }
    ];

    repairList.value = [
      {
        level: "不拆机维修与清洁保养服务",
        content: "简易故障排除",
        item: "不拆机清洁、调整设置、重装系统、恢复出厂设置",
        price: "50元"
      },
      {
        level: "不拆机维修与清洁保养服务",
        content: "数据备份",
        item: "咨询/辅助数据备份",
        price: "50元"
      },
      {
        level: "不拆机维修与清洁保养服务",
        content: "软件升级",
        item: "软件升级",
        price: "50元"
      },
      {
        level: "不拆机维修与清洁保养服务",
        content: "不拆机维修",
        item: "不拆机情况下的机械零部件维修或更换比如电池后盖，外置天线等",
        price: "50元"
      },
      {
        level: "拆机简单维修",
        content: "拆机维修：机械零部件更换",
        item:
          "机械零部件：前壳组件、后壳组件、内置电池、TP组件、显示模组、听筒、扬声器、麦克风、振动器、摄像头、射频连接线、内置天线、按键、侧键、FPC、转轴等",
        price: "80元"
      },
      {
        level: "拆机简单维修",
        content: "拆机维修：接口类器件更换",
        item:
          "接口类：电池连接器、耳机连接器、IO连接器、SIM卡座、存储卡卡座、 网口、电话口、插座等",
        price: "100元"
      },
      {
        level: "拆机简单维修",
        content: "重焊",
        item: "针对因器件虚焊原因导致的故障，采用重焊加焊授权器件的方式修复",
        price: "100元"
      },

      {
        level: "拆机简单维修",
        content: "更换主板",
        item: "更换主板",
        price: "100元"
      }
    ];

    repairList1.value = [
      {
        level: "不拆机维修与清洁保养服务",
        content: "简易故障排除",
        item: "不拆机清洁、调整设置、重装系统、恢复出厂设置",
        price: "50元"
      },
      {
        level: "不拆机维修与清洁保养服务",
        content: "数据备份",
        item: "咨询/辅助数据备份",
        price: "50元"
      },
      {
        level: "不拆机维修与清洁保养服务",
        content: "软件升级",
        item: "软件升级",
        price: "50元"
      },
      {
        level: "不拆机维修与清洁保养服务",
        content: "不拆机维修",
        item: "不拆机情况下的机械零部件维修或更换比如电池后盖，外置天线等",
        price: "50元"
      },
      {
        level: "拆机简单维修",
        content: "拆机维修：机械零部件更换",
        item:
          "机械零部件：前壳组件、后壳组件、内置电池、TP组件、显示模组、听筒、扬声器、麦克风、振动器、摄像头、射频连接线、内置天线、按键、侧键、FPC、转轴等",
        price: "80元"
      },
      {
        level: "拆机简单维修",
        content: "拆机维修：接口类器件更换",
        item:
          "接口类：电池连接器、耳机连接器、IO连接器、SIM卡座、存储卡卡座、 网口、电话口、插座等",
        price: "100元"
      },
      {
        level: "拆机简单维修",
        content: "重焊",
        item: "针对因器件虚焊原因导致的故障，采用重焊加焊授权器件的方式修复",
        price: "100元"
      },

      {
        level: "拆机简单维修",
        content: "更换主板",
        item: "更换主板",
        price: "100元"
      },
      {
        level: '拆机复杂维修',
        content: "维修除主板CPU、FLASH和接口类以外的器件",
        item: "主板器件：电阻、电容、电感、二极管、WIFI芯片、蓝牙芯片等器件",
        price: "150元"
      }
    ];

    onBeforeMount(() => {
      let pid = sessionStorage.getItem("pid");
      // getPresetPrice(pid)
    });

    return {
      phoneList,
      show,
      selectphone,
      show1,
      tabledata,
      show2,
      show3,
      show4,
      show5,
      show6,
      tabledata1,
      tabledata2,
      tabledata3,
      tabledata4,
      tabledata5,
      repairList,
      repairList1
    };
  }
});
</script>

<style scoped>
.container {
  position: relative;
}

.title1 {
  font-size: 28px;
  font-style: SourceHanSansSC-bold;

  color: black;
  text-decoration: none;
  font-weight: bold;
}

.title2 {
  font-size: 28px;
  font-style: SourceHanSansSC-bold;

  color: #535353 10000%;
  text-decoration: none;
  font-weight: regular;
}

.title {
  font-size: 28px;
  font-style: SourceHanSansSC-bold;

  color: black;
  text-decoration: none;
  font-weight: bold;
}

/* .content{
    font-size:18px;
    font-style: SourceHanSansSC-bold;
    
    color:black;
    text-decoration:none;
    
} */

.content {
  font-size: 18px;
  color: #101010;
  font-style: SourceHanSansSC;
}

input {
  border: 2px solid #b8b8b8;
  width: 1170px;
  font-size: 18px;

  padding: 0.5vw 0 0.5vw 2vw;
}

.color {
  cursor: pointer;
  font-size: 20px;
}

.color:hover {
  cursor: pointer;
  font-size: 20px;
  color: red;
}

.color:active {
  cursor: pointer;
  font-size: 20px;
  color: red;
}

.box {
  border: 1px solid black;
  width: 330px;
  height: 220px;
  display: flex;
  flex-shrink: 0;
}

.box_content {
  margin-top: 45px;
  margin-left: 20px;
  text-align: left;
}

.show {
  display: flex;
  max-width: 1250px;
  /* margin-left:7vw; */
  margin-top: 3vw;
  justify-content: center;
}

.img_size {
  height: 80px;
  margin-left: 58px;
  margin-top: 45px;
}

.image {
  height: 643px;
  position: relative;
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url("../assets/images/item.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position-y: 50%;
}

.title2 {
  font-size: 48px;
  font-style: SourceHanSansSC-bold;
  color: black;
  text-decoration: none;
  position: absolute;
  top: 45%;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  color: white;
  font-weight: bold;
}

:deep() .el-table--scrollable-x .el-table__body-wrapper {
  overflow: hidden;
}
</style>
